module.exports = __webpack_public_path__ + "static/media/location.6ef56a00.svg";